import { WorkOrderDetailView } from '@/features/Aircrafts/AircraftDetailView/WorkOrderDetailView/WorkOrderDetailView';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const workOrderDetailSearchSchema = z.object({
    tab: z.enum(['line-items', 'removal-installation']).optional().default('line-items'),
    filter: z.string().optional(),
});

export const Route = createFileRoute(
    '/aircrafts/$aircraftId/work_orders/$workOrderId/',
)({
    component: WorkOrderDetailView,
    validateSearch: workOrderDetailSearchSchema,
});
